import { Lightbulb } from "lucide-react";
import { Button } from "@ui";
import type { LocationSuggestion } from "../lib/types";
import { LocationAutocomplete } from "./location-autocomplete";
import { ProgressChecklist } from "./progress-checklist";

interface Props {
  selected: LocationSuggestion | null;
  onSelect: (loc: LocationSuggestion | null) => void;
  onSubmit: () => void;
  loading: boolean;
  error: string | null;
}

export function AnalysisForm({
  selected,
  onSelect,
  onSubmit,
  loading,
  error,
}: Props) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (selected && !loading) onSubmit();
      }}
      className="px-4 pt-4 pb-2"
      noValidate
    >
      {/* Intro copy only helps when the form is empty. Once a Location
          is picked (via autocomplete OR via the /emplacement/:slug
          deep-link route which preselects), the intro is noise and just
          pushes the selected-input pill down the page. */}
      {!selected && (
        <p className="mb-3 text-sm text-slate-600 leading-relaxed">
          Sélectionnez un local référencé sur inSiti. L'analyse utilise ses
          caractéristiques (surface, vitrine, flux, environnement) et la zone
          autour pour produire un rapport en 5 sections.
        </p>
      )}

      <LocationAutocomplete
        value={selected}
        onChange={onSelect}
        disabled={loading}
      />

      {error && (
        <div
          role="alert"
          className="mt-2 rounded-lg bg-red-50 px-3 py-2.5 text-sm text-red-700"
        >
          {error}
        </div>
      )}

      <Button
        type="submit"
        size="lg"
        icon={Lightbulb}
        loading={loading}
        disabled={!selected || loading}
        className="mt-3 w-full justify-center"
      >
        {loading ? "Analyse en cours…" : "Analyser ce local"}
      </Button>

      {loading && <ProgressChecklist />}
    </form>
  );
}
